export default __webpack_public_path__ + "static/media/wb3.19254d96.jpg";